import type { FunctionComponent } from 'react'
import React, { useContext } from 'react'

import { PillButtonPage } from '../../../../../shared/pages/PillButtonPage'
import { ToolContext } from '../../../../../shared/state/appContext'
import globalStyles from '../../../../../shared/styles/GlobalStyles.module.scss'
import { trackAppointmentBookingSelection } from '../../../../../shared/utils/tracking/tracking'
import { DescribeCaseFlow, TechDeviceFlow, TechSystemFlow } from '../../../pageFlowData'
import { techDeviceData } from './data'

export const TechDevice: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    tech: { techDevice },
    triage: { type },
  } = state

  const chooseStep = (id: string) => {
    switch (id) {
      case 'desktop':
      case 'laptop':
      case 'mobiles':
      case 'tablet':
        return TechSystemFlow
      default:
        return DescribeCaseFlow
    }
  }

  const handleTracking = (id: string, index: number) => {
    trackAppointmentBookingSelection(type, TechDeviceFlow.VIEW_NAME, { id, index })
  }

  const handleDispatch = (id: string) => {
    dispatch({ type: 'UPDATE_TECH_DEVICE', data: id })
    const step = chooseStep(id)
    dispatch({ type: 'UPDATE_STEP', data: step.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: step.PROGRESS_VALUE })
  }

  const handleSubmit = (id: string, index: number) => {
    handleTracking(id, index)
    handleDispatch(id)
  }

  const { buttons, imgObj, title } = techDeviceData

  return (
    <div className={globalStyles.fullWidthButton}>
      <PillButtonPage
        buttons={buttons}
        defaultValue={techDevice}
        handleSubmit={handleSubmit}
        imgObj={imgObj}
        title={title}
      />
    </div>
  )
}
